<template>
  <div>
    <span>
      {{ label }}
      <input type="text" v-model="value" />
    </span>
  </div>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";

export default {
  name: "text-input-component",
  mixins: [inputComponentMixin]
};
</script>
